import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Paper,
} from "@mui/material";

const fmt = (n) => (n >= 1000 ? `₹${(n / 1000).toFixed(1)}K` : `₹${n}`);
const days = (d) => `${Math.round(d)}d`;

const Product = ({ product_name, sku_code, brand }) => (
  <Box>
    <Typography fontSize={13} fontWeight={500}>{product_name}</Typography>
    <Typography fontSize={11} color="text.secondary">
      {sku_code} · {brand}
    </Typography>
  </Box>
);

export default function FastMovers({ data = [] }) {
  const total = data.reduce((a, x) => a + x.fast_moving_inventory_value, 0);

  return (
    <Box mb={3}>
      <Box display="flex" justifyContent="space-between" mb={1.5}>
        <Box display="flex" gap={1} alignItems="center">
          <Box width={3} height={16} bgcolor="#639922" borderRadius={1} />
          <Typography fontSize={13.5} fontWeight={500}>
            Fast movers
          </Typography>
        </Box>
        <Typography fontSize={11.5} color="text.secondary">
          {data.length} SKUs · {fmt(total)}
        </Typography>
      </Box>

      <Paper variant="outlined" sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead sx={{ background: "var(--color-background-secondary)" }}>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>30d sales</TableCell>
              <TableCell>Stock</TableCell>
              <TableCell>Cover</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((r) => {
              const low = r.stock_cover_days_30d < 20;

              return (
                <TableRow key={r.sku_code} hover>
                  <TableCell><Product {...r} /></TableCell>
                  <TableCell>
                    <Chip size="small" label={r.category} />
                  </TableCell>
                  <TableCell sx={{ color: "success.main", fontWeight: 500 }}>
                    {r.units_sold_30d}
                  </TableCell>
                  <TableCell>{r.inventory_units}</TableCell>
                  <TableCell sx={{ color: low ? "error.main" : "inherit" }}>
                    {days(r.stock_cover_days_30d)}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>{fmt(r.fast_moving_inventory_value)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}